const ERRORS = {
  USER_NOT_FOUND: '找不到用戶',
  UNAUTHORIZED: '未授權',
  INVALID_OLD_PASSWORD: '舊密碼錯誤',
};

export const getErrorMsg = (code, errors = {}) => {
  const msg = errors ? { ...ERRORS, ...errors }[code] : ERRORS[code];
  if (!msg) return '發生錯誤，請重新再試';
  return msg;
};

export default {};
